import type { ProductSelectionType, SelectedProductsType } from '../AppsTwitch.types'

export const isSelectedProductSelection = (
  productSelection: ProductSelectionType,
): productSelection is Extract<ProductSelectionType, SelectedProductsType> =>
  productSelection.type === 'SELECTED_PRODUCTS'
